<div class="wrapper"
	[ngClass]="{'ite-theme': theme === 'ite-theme'}"
	[class.edit-mode]="isSelected()">
	<!-- (clickOutside)="setSelected(false)" -->
	<div
		class="action-description"
		(click)="setSelected(true);log(action)"
	>
		<div class="action-entity">
			<div class="used-contexts" *ngIf="action.useContext && ! isSelected()">
				in context
				<ng-container *ngIf="action.contexts?.length; else noContextSet">
					<strong class="context-label" *ngFor="let contextCode of action.contexts; let i = index;">
						{{ contextCode | valueToLabel : interactivityEditorService?.projectContextOptions }}<span class="not-last" *ngIf="i < action.contexts.length - 1">, </span>
					</strong>
				</ng-container>
				<ng-template #noContextSet>
					<strong class="context-label">
						default (no context set)
					</strong>
				</ng-template>
			</div>
			<span *ngIf="category !== 'widget' && shortText" [innerHTML]="shortText"></span>
			
			<!-- exeption for property, which has a dynamic value in shortText -->

			<span *ngIf="category === 'widget' && action?.entity === 'widget'">
				Change <strong class="entity">{{ entityLabelsByExtendedId['Widget:' + action?.parameters[0]?.value] || 'WIDGET' | translate}}</strong>
				<i *ngIf="objectHasDatasource(action?.parameters[0]?.value)" class="fa fa-plug"></i>
			</span>
			<span *ngIf="category === 'widget' && action?.entity === 'group'">
				Change <strong class="entity">{{ entityLabelsByExtendedId['Group:' + action?.parameters[0]?.value] || action?.parameters[0]?.value || 'WIDGETS_BY_TAG' | translate}}</strong>
				<i *ngIf="objectHasDatasource(action?.parameters[0]?.value)" class="fa fa-plug"></i>
			</span>
		</div>
		<div class="action-command" *ngIf=" ! isSelected() && category !== 'form'">
			<span>
				<span class="entity"> 
					{{ closedTextProperty }} {{ closedTextCommand }}
					<i *ngIf="propertyHasDataSource === true" class="fa fa-plug"></i>
				</span>
				<span>
					<i *ngIf="closedTextProperty !== '' && closedTextValue !== ''" class="fa fa-long-arrow-right"></i>
				</span>

				<span class="entity">
					{{ closedTextValue }}
					<i *ngIf="valueHasDataSource === true" class="fa fa-plug"></i>
				</span>
			</span>
		</div>
	</div>
	<div class="read-only-mode" [hidden]="isSelected()">
		<div class="delete-action action-icon-button" (click)="deleteAction()" [title]="'DELETE' | translate">
			<i class="fa fa-trash"></i>
		</div>
		<div class="drag-handle-bars action-icon-button">
			<i class="fa fa-bars"></i>
		</div>
	</div>


	<div class="edit-mode" *ngIf="isSelected()">
		<div *ngIf="action.useContext && interactivityEditorService?.projectContextOptions?.length" class="parameter-wrapper">
			<ie-form-field [label]="'CONTEXTS' | translate" class="context-selector">
				<bb-entity-selector
					[(ngModel)]="action.contexts"
					(ngModelChange)="onContentChange()"
					name="'context_' + action.id"
					[options]="interactivityEditorService?.projectContextOptions"
					[multi]="true"
					placeholder="Select or leave blank for default context"
					theme="dark"
				></bb-entity-selector>
			</ie-form-field>
		</div>

		<span *ngIf="interactivityEditorService?.projectContextOptions?.length"
			[title]="'CONTEXT' | translate"
			[class.active]="action.useContext"
			class="context-button action-icon-button"
			(click)="action.useContext = !action.useContext; onContentChange()"
		>
			<i class="fa-solid fa-chart-network"></i>
		</span>
		<div class="duplicate-action action-icon-button" (click)="duplicateAction()" [title]="'DUPLICATE' | translate">
			<i class="fa fa-copy"></i>
		</div>
		<div class="delete-action action-icon-button" (click)="deleteAction()" [title]="'DELETE' | translate">
			<i class="fa fa-trash"></i>
		</div>
		<div class="action-content" (mousedown)="onContentMouseDown($event)">
			<bb-icon-list [options]="subCategoryList" [(ngModel)]="selectedSubCategory" (ngModelChange)="onCategoryClicked($event)"></bb-icon-list>
			<bb-radio-list [options]="radioOptions" [(ngModel)]="selectedRadioOption" (ngModelChange)="onRadioChange($event)"></bb-radio-list>
			<div *ngIf="commandComponent" class="parameter-wrapper">
				<ie-form-field [label]="commandComponent.label" [useMacroSuggestions]="commandComponent?.configuration?.useMacroSuggestions" [disabledMacroHotkey]="commandComponent?.configuration?.disabledMacroHotkey">
					<ng-container [ngSwitch]="commandComponent.iType">
						<input
							*ngSwitchDefault
							[(ngModel)]="action.command"
							type="text"
							class="ie-form-field-styling"
							[name]="'commandComponent_' + action.id"
							[placeholder]="commandComponent.placeholder || ''"
							(change)="onContentChange()"
						/>

						<bb-entity-selector
							*ngSwitchCase="'entitySelector'"
							[(ngModel)]="action.command"
							[filterSet]="commandComponent.configuration?.filterSet"
							(ngModelChange)="onContentChange()"
							[name]="'commandComponent_' + action.id"
							[entityType]="commandComponent.configuration?.entityType"
							[options]="commandComponent.configuration?.options"
							[extendable]="commandComponent.configuration?.extendable"
							[hideIcons]="commandComponent.configuration?.hideIcons"
							theme="dark"
						></bb-entity-selector>
					</ng-container>

				</ie-form-field>
			</div>
			<div *ngIf="actionText">
				{{ actionText | translate }}
			</div>
			<div class="parameters-container">
				<div class="parameter-wrapper" *ngFor="let comp of parameterComponents; trackBy: paramComponentsTrackBy;">
					<ng-container>
						<div [ngSwitch]="comp.iType"
							[hidden]="comp.paramIndex === 1 && !action.parameters[0]?.value || comp.paramIndex > 1 && (!action.parameters[0]?.value || !action.parameters[1]?.value)" *ngIf="action.parameters[comp.paramIndex]">
							<ie-form-field [label]="comp.label" *ngSwitchDefault
								[useDataSource]="comp.configuration?.useDataSource"
								[useMacroSuggestions]="comp.configuration?.useMacroSuggestions"
								[disabledMacroHotkey]="comp.configuration?.disabledMacroHotkey"
								(dataSourceClicked)="dataSourceService.onDataSourceClicked(action.parameters[comp.paramIndex], dataSourceTemplate)"
								[dataSourceActive]="action.parameters[comp.paramIndex]?.value?.datasource"
							>
								<input
								*ngIf="action.parameters[comp.paramIndex].value?.datasource?.sourceType"
								[(ngModel)]="action.parameters[comp.paramIndex].value.datasource.defaultValue"
								type="text" class="ie-form-field-styling" [name]="action.parameters[comp.paramIndex].name + '_' + action.id" [placeholder]="comp.placeholder || ''" (change)="onContentChange(comp.paramIndex === 2)"
								/>
								
								<input
								*ngIf="!action.parameters[comp.paramIndex].value?.datasource"
								[(ngModel)]="action.parameters[comp.paramIndex].value"
								type="text" class="ie-form-field-styling" [name]="action.parameters[comp.paramIndex].name + '_' + action.id" [placeholder]="comp.placeholder || ''" (change)="onContentChange(comp.paramIndex === 2)"
								/>
							</ie-form-field>
								<!--
									needed components:
									scriptEditor
									selector ( localStorageNameSelector / widgetPropertySelector ). Set option list with icon, aliasses prefix and postfix (language i.e.)
									buttonList
									timeCodeSelector
								
								-->

							<ie-form-field [label]="comp.label" *ngSwitchCase="'select'"
								[useDataSource]="comp.configuration?.useDataSource"
								[useMacroSuggestions]="comp.configuration?.useMacroSuggestions"
								[disabledMacroHotkey]="comp.configuration?.disabledMacroHotkey"
								(dataSourceClicked)="dataSourceService.onDataSourceClicked(action.parameters[comp.paramIndex], dataSourceTemplate)"
								[dataSourceActive]="action.parameters[comp.paramIndex].value?.datasource"
							>
								<bb-select
									*ngIf="action.parameters[comp.paramIndex].value?.datasource?.sourceType"
									[(ngModel)]="action.parameters[comp.paramIndex].value.datasource.defaultValue"
									theme="dark"
									class="ie-form-field-styling" (change)="onContentChange(comp.paramIndex === 2)"
								>
									<option *ngFor="let option of comp.configuration?.options" [value]="option.value" [selected]="option.value === action.parameters[comp.paramIndex].value.datasource.defaultValue">
										{{ option.label }}
									</option>
								</bb-select>
								<bb-select
									*ngIf="!action.parameters[comp.paramIndex].value?.datasource"
									[(ngModel)]="action.parameters[comp.paramIndex].value"
									theme="dark"
									class="ie-form-field-styling" (change)="onContentChange(comp.paramIndex === 2)"
								>
									<option *ngFor="let option of comp.configuration?.options" [value]="option.value" [selected]="option.value === action.parameters[comp.paramIndex].value">
										{{ option.label }}
									</option>
								</bb-select>
							</ie-form-field>


							<ie-form-field [label]="comp.label" *ngSwitchCase="'timeCodeSelector'"
								[useDataSource]="comp.configuration?.useDataSource"
								[useMacroSuggestions]="comp.configuration?.useMacroSuggestions"
								[disabledMacroHotkey]="comp.configuration?.disabledMacroHotkey"
								(dataSourceClicked)="dataSourceService.onDataSourceClicked(action.parameters[comp.paramIndex], dataSourceTemplate)"
								[dataSourceActive]="action.parameters[comp.paramIndex]?.value?.datasource"
							>
								<bb-timecode-editor
									*ngIf="action.parameters[comp.paramIndex].value?.datasource?.sourceType"
									[(ngModel)]="action.parameters[comp.paramIndex].value.datasource.defaultValue"
									class="ie-form-field-styling"
									[name]="action.parameters[comp.paramIndex].name + '_' + action.id"
									(change)="onContentChange(comp.paramIndex === 2)"
									[min]="0"
								></bb-timecode-editor>
								<bb-timecode-editor
									*ngIf="!action.parameters[comp.paramIndex].value?.datasource"
									[(ngModel)]="action.parameters[comp.paramIndex].value"
									class="ie-form-field-styling"
									[name]="action.parameters[comp.paramIndex].name + '_' + action.id"
									(change)="onContentChange(comp.paramIndex === 2)"
									[min]="0"
								></bb-timecode-editor>
							</ie-form-field>

							
							<ie-form-field [label]="comp.label" 
								*ngSwitchCase="'entitySelector'"
								[useDataSource]="comp.configuration?.useDataSource"
								[useMacroSuggestions]="comp.configuration?.useMacroSuggestions"
								[disabledMacroHotkey]="comp.configuration?.disabledMacroHotkey"
								(dataSourceClicked)="dataSourceService.onDataSourceClicked(action.parameters[comp.paramIndex], dataSourceTemplate)"
								[dataSourceActive]="action.parameters[comp.paramIndex].value?.datasource"
							>
								<bb-entity-selector
									*ngIf="action.parameters[comp.paramIndex].value?.datasource?.sourceType"
									[(ngModel)]="action.parameters[comp.paramIndex].value.datasource.defaultValue"
									[filterSet]="comp.configuration?.filterSet"
									(ngModelChange)="onContentChange(comp.paramIndex === 2)"
									[name]="action.parameters[comp.paramIndex].name + '_' + action.id"
									[entityType]="comp.configuration?.entityType"
									[options]="comp.configuration?.options"
									[extendable]="comp.configuration?.extendable"
									[hideIcons]="comp.configuration?.hideIcons"
									theme="dark"
								></bb-entity-selector>
								<bb-entity-selector
									*ngIf="!action.parameters[comp.paramIndex].value?.datasource"
									[(ngModel)]="action.parameters[comp.paramIndex].value"
									[filterSet]="comp.configuration?.filterSet"
									(ngModelChange)="onContentChange(comp.paramIndex === 2)"
									[name]="action.parameters[comp.paramIndex].name + '_' + action.id"
									[entityType]="comp.configuration?.entityType"
									[options]="comp.configuration?.options"
									[extendable]="comp.configuration?.extendable"
									[hideIcons]="comp.configuration?.hideIcons"
									theme="dark"
								></bb-entity-selector>
							</ie-form-field>

							<ie-form-field
								*ngSwitchCase="'text'"
								[label]="comp.label"
								[useDataSource]="true"
								[useMacroSuggestions]="comp.configuration?.useMacroSuggestions"
								[disabledMacroHotkey]="comp.configuration?.disabledMacroHotkey"
								[dataSourceActive]="action.parameters[comp.paramIndex].value?.datasource"
								(dataSourceClicked)="dataSourceService.onDataSourceClicked(action.parameters[comp.paramIndex], dataSourceTemplate)"
							>
								<input 
									*ngIf="action.parameters[comp.paramIndex].value?.datasource?.sourceType"
									[(ngModel)]="action.parameters[comp.paramIndex].value.datasource.defaultValue"
									type="text"
									class="ie-form-field-styling"
									(change)="onContentChange(comp.paramIndex === 2)"
									[name]="action.parameters[comp.paramIndex].name + '_' + action.id"
									[placeholder]="comp.placeholder || ''"
								/>
								<input 
									*ngIf="!action.parameters[comp.paramIndex].value?.datasource"
									[(ngModel)]="action.parameters[comp.paramIndex].value"
									type="text"
									class="ie-form-field-styling"
									(change)="onContentChange(comp.paramIndex === 2)"
									[name]="action.parameters[comp.paramIndex].name + '_' + action.id"
									[placeholder]="comp.placeholder || ''"
								/>
							</ie-form-field>

							<ie-form-field [label]="comp.label" *ngSwitchCase="'scriptEditor'"
								[useDataSource]="comp.configuration?.useDataSource"
								[useMacroSuggestions]="comp.configuration?.useMacroSuggestions"
								[disabledMacroHotkey]="comp.configuration?.disabledMacroHotkey"
								(dataSourceClicked)="dataSourceService.onDataSourceClicked(action.parameters[comp.paramIndex], dataSourceTemplate)"
								[dataSourceActive]="action.parameters[comp.paramIndex].value?.datasource"
							>
								<bb-code-editor
									*ngIf="action.parameters[comp.paramIndex].value?.datasource?.sourceType"
									(modalClose)="setSelected(false)"
									[useMacroSuggestions]="true"
									[inModal]="true"
									[(ngModel)]="action.parameters[comp.paramIndex].value.datasource.defaultValue"
									[name]="action.parameters[comp.paramIndex].name + '_' + action.id"
									[placeholder]="comp.placeholder || ''" (change)="onContentChange(comp.paramIndex === 2)"
								></bb-code-editor>
								<bb-code-editor
									*ngIf="!action.parameters[comp.paramIndex].value?.datasource"
									(modalClose)="setSelected(false)"
									[useMacroSuggestions]="true"
									[inModal]="true"
									[(ngModel)]="action.parameters[comp.paramIndex].value"
									[name]="action.parameters[comp.paramIndex].name + '_' + action.id"
									[placeholder]="comp.placeholder || ''" (change)="onContentChange(comp.paramIndex === 2)"
								></bb-code-editor>
							</ie-form-field>

							<ie-form-field [label]="comp.label" *ngSwitchCase="'textarea'"
								[allowMaximize]="true"
								[useDataSource]="comp.configuration?.useDataSource"
								[useMacroSuggestions]="comp.configuration?.useMacroSuggestions"
								[disabledMacroHotkey]="comp.configuration?.disabledMacroHotkey"
								(dataSourceClicked)="dataSourceService.onDataSourceClicked(action.parameters[comp.paramIndex], dataSourceTemplate)"
								[dataSourceActive]="action.parameters[comp.paramIndex].value?.datasource"
							>
								<textarea
									*ngIf="action.parameters[comp.paramIndex].value?.datasource?.sourceType"
									[(ngModel)]="action.parameters[comp.paramIndex].value.datasource.defaultValue"
									class="ie-form-field-styling" type="text" [name]="action.parameters[comp.paramIndex].name + '_' + action.id" [placeholder]="comp.placeholder || ''" (change)="onContentChange(comp.paramIndex === 2)"
								>
								</textarea>
								<textarea
									*ngIf="!action.parameters[comp.paramIndex].value?.datasource"
									[(ngModel)]="action.parameters[comp.paramIndex].value"
									class="ie-form-field-styling" type="text" [name]="action.parameters[comp.paramIndex].name + '_' + action.id" [placeholder]="comp.placeholder || ''" (change)="onContentChange(comp.paramIndex === 2)"
								>
								</textarea>
							</ie-form-field>

							<ie-form-field [label]="comp.label" *ngSwitchCase="'slider'" class="param-slider"
								[useDataSource]="comp.configuration?.useDataSource"
								[useMacroSuggestions]="comp.configuration?.useMacroSuggestions"
								[disabledMacroHotkey]="comp.configuration?.disabledMacroHotkey"
								(dataSourceClicked)="dataSourceService.onDataSourceClicked(action.parameters[comp.paramIndex], dataSourceTemplate)"
								[dataSourceActive]="action.parameters[comp.paramIndex].value?.datasource"
							>
								<mat-slider
									*ngIf="action.parameters[comp.paramIndex].value?.datasource?.sourceType"
									thumbLabel
									[displayWith]="comp.configuration?.formatter ? comp.configuration?.formatter : null"
									[(ngModel)]="action.parameters[comp.paramIndex].value.datasource.defaultValue"
									[min]="comp.configuration?.value_min || 0" [max]="comp.configuration?.value_max || 1" [step]="comp.configuration?.value_step || 0.05" (change)="onContentChange(comp.paramIndex === 2)"></mat-slider>
									
								<mat-slider
									*ngIf="!action.parameters[comp.paramIndex].value?.datasource"
									thumbLabel
									[displayWith]="comp.configuration?.formatter ? comp.configuration?.formatter : null"
									[(ngModel)]="action.parameters[comp.paramIndex].value"
									[min]="comp.configuration?.value_min || 0" [max]="comp.configuration?.value_max || 1" [step]="comp.configuration?.value_step || 0.05" (change)="onContentChange(comp.paramIndex === 2)"></mat-slider>

								<!-- <input type="range" [name]="param.name" [(ngModel)]="action.parameters[comp.paramIndex].value"/> -->
							</ie-form-field>

							<ie-form-field [label]="comp.label" *ngSwitchCase="'checkbox'" class="checkbox"
								[useDataSource]="comp.configuration?.useDataSource"
								[useMacroSuggestions]="comp.configuration?.useMacroSuggestions"
								[disabledMacroHotkey]="comp.configuration?.disabledMacroHotkey"
								(dataSourceClicked)="dataSourceService.onDataSourceClicked(action.parameters[comp.paramIndex], dataSourceTemplate)"
								[dataSourceActive]="action.parameters[comp.paramIndex].value?.datasource"
							>
								<input
									*ngIf="action.parameters[comp.paramIndex].value?.datasource?.sourceType"
									[(ngModel)]="action.parameters[comp.paramIndex].value.datasource.defaultValue"
									type="checkbox" class="ie-form-field-styling" [name]="action.parameters[comp.paramIndex].name + '_' + action.id" [placeholder]="comp.placeholder || ''" (change)="onContentChange(comp.paramIndex === 2)"/>
								<input
									*ngIf="!action.parameters[comp.paramIndex].value?.datasource"
									[(ngModel)]="action.parameters[comp.paramIndex].value"
									type="checkbox" class="ie-form-field-styling" [name]="action.parameters[comp.paramIndex].name + '_' + action.id" [placeholder]="comp.placeholder || ''" (change)="onContentChange(comp.paramIndex === 2)"/>
							</ie-form-field>

							<ie-form-field [label]="comp.label" *ngSwitchCase="'number'" class="param-slider"
								[useDataSource]="comp.configuration?.useDataSource"
								[useMacroSuggestions]="comp.configuration?.useMacroSuggestions"
								[disabledMacroHotkey]="comp.configuration?.disabledMacroHotkey"
								(dataSourceClicked)="dataSourceService.onDataSourceClicked(action.parameters[comp.paramIndex], dataSourceTemplate)"
								[dataSourceActive]="action.parameters[comp.paramIndex].value?.datasource"
							>
								<input
									*ngIf="action.parameters[comp.paramIndex].value?.datasource?.sourceType"
									[(ngModel)]="action.parameters[comp.paramIndex].value.datasource.defaultValue"
									type="number" class="ie-form-field-styling" [name]="action.parameters[comp.paramIndex].name + '_' + action.id" [placeholder]="comp.placeholder || ''" (change)="onContentChange(comp.paramIndex === 2)"/>
								<input
									*ngIf="!action.parameters[comp.paramIndex].value?.datasource"
									[(ngModel)]="action.parameters[comp.paramIndex].value"
									type="number" class="ie-form-field-styling" [name]="action.parameters[comp.paramIndex].name + '_' + action.id" [placeholder]="comp.placeholder || ''" (change)="onContentChange(comp.paramIndex === 2)"/>
							</ie-form-field>

						</div>
					</ng-container>
				</div>
			</div>
		</div>
	</div>
</div>
<ng-template #dataSourceTemplate>
	<bb-data-source-picker
		*ngIf="dataSourceService.dataSourceModel !== undefined"
		[model]="dataSourceService.dataSourceModel"
		(ok)="dataSourceService.onDataSourceOk($event); onDataSourceChanged();"
		(remove)="dataSourceService.onDataSourceRemove($event); onDataSourceChanged();"
		(cancel)="dataSourceService.onDataSourceCancel($event)"
		(closed)="dataSourceService.onDataPickerClosed()"
	></bb-data-source-picker>
</ng-template>
